import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PartsPersonnelComponent } from './parts-personnel.component';

const routes: Routes = [
  {
    path: '',
    component: PartsPersonnelComponent,
    data: { pageTitle: 'navigation.partsAdvisor' }
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PartsPersonnelRoutingModule { }
